
import { theme } from "../../../../../helpers/theme";
import { Tab, Tabs } from "@mui/material";



interface FormButton {
    value: number,
    handleChangeButton: (event: unknown, newValue: number) => void;
    buttonName: string[];
}

export const FormButton = ({ value, handleChangeButton, buttonName }: FormButton) => {

    return (
        <Tabs
            value={value}
            onChange={handleChangeButton}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
        >
            {
                buttonName.map((item) => (
                    <Tab
                        label={item}
                        key={item}
                        sx={{
                            backgroundColor: `${theme.colors.gray04_background}`

                        }}
                    />

                ))
            }
        </Tabs >

    )
};
